import { produce } from 'immer'
import { TAction } from './action'
import { PosthogActions, TFeatureFlags, TState } from './types'

const INITIAL_STATE: TState = {
  status: 'idle',
  featureFlags: [] as TFeatureFlags[],
  payloads: null,
}

const reducer = (state = INITIAL_STATE, action: TAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case PosthogActions.SET_FEATURE_FLAGS:
        draft.status = 'ok'
        draft.featureFlags = action.payload.flags
        draft.payloads = action.payload.payloads
        break

      case PosthogActions.CLEAR_FEATURE_FLAGS:
        return INITIAL_STATE

      default:
    }
  })

export default reducer
